var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-date-picker", {
    attrs: {
      type: _vm.datePickerType,
      format: _vm.formattedDisplay,
      "value-format": _vm.formattedValue,
      disabled: _vm.disabled
    },
    on: { change: _vm.onChanged },
    model: {
      value: _vm.date,
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }